const KEY = "hr_guest_identity";

export const getGuest = () => {
  try {
    const g = JSON.parse(localStorage.getItem(KEY) || "null");
    return g && g.name && g.phone && g.email ? g : null;
  } catch {
    return null;
  }
};

export const saveGuest = (g) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ name: g.name || "", phone: g.phone || "", email: g.email || "" }));
  } catch {}
};
